import { ICONS } from '@frontend/icons';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export interface ObjectListRefreshBannerProps {
    /** Entities created since the last fetch. */
    count: number;
    /** True when a row changed but could not be refetched on its own. */
    hasStaleRows?: boolean;
    onRefresh: () => void;
    onDismiss: () => void;
}

export const ObjectListRefreshBanner = (props: ObjectListRefreshBannerProps) => {
    if (props.count <= 0 && !props.hasStaleRows) return null;
    const SyncIcon = ICONS.NAVIGATION.SYNC;
    const CloseIcon = ICONS.BUTTON.CLOSE;

    return (
        <div
            role='status'
            data-testid='object-list-refresh-banner'
            className='bg-status-info/10 border-border-default flex items-center justify-between gap-2 border-b px-4 py-1'>
            <button
                type='button'
                data-testid='object-list-refresh-banner-refresh'
                onClick={props.onRefresh}
                className='text-foreground-default hover:text-brand-primary group flex min-h-0 cursor-pointer items-center gap-2 border-0 bg-transparent p-0 text-sm transition-colors hover:underline'>
                <SyncIcon className='text-status-info group-hover:text-brand-primary shrink-0 transition-colors' />
                {props.count > 0 ? (
                    <FormattedMessage
                        id='components.list-v2.object-list.object-list-refresh-banner.message'
                        description='Notice above a list telling the user that new data was created elsewhere and that the list is not showing it until it is refreshed'
                        defaultMessage='New data available'
                    />
                ) : (
                    <FormattedMessage
                        id='components.list-v2.object-list.object-list-refresh-banner.stale-message'
                        description='Notice above a list telling the user that something in the list changed but could not be updated automatically, so the list needs refreshing'
                        defaultMessage='This list is out of date'
                    />
                )}
            </button>
            <button
                type='button'
                aria-label='dismiss'
                data-testid='object-list-refresh-banner-dismiss'
                onClick={props.onDismiss}
                className='text-brand-muted hover:text-foreground-default shrink-0 cursor-pointer p-0.5'>
                <CloseIcon />
            </button>
        </div>
    );
};
